import React from 'react';
import { Typography, ImageList, ImageListItem } from '@common-ui/ui';
import workItemEnum from '../../enums/workItemEnum';
import './styles.css';

const WorkItemPhotoNotes = ({ image }) => {
  return (
    <div className="workItemPhotoNotes">
      {image && image.length > 0 && (
        <>
          <Typography variant="h5" className="workItem__header">
            {workItemEnum.PHOTO_NOTES}
          </Typography>
          <ImageList cols={3} sx={{ my: 0 }}>
            {image.map(({ src }, index) => (
              <ImageListItem key={index}>
                <div className="workItem__imageContainer">
                  <img alt="columbia info images" src={src} width={360} height={'auto'} />
                </div>
              </ImageListItem>
            ))}
          </ImageList>
        </>
      )}
    </div>
  );
};
export default WorkItemPhotoNotes;
